import React, { useEffect } from 'react';
import Content from 'app/components/common/Content.jsx';
import { Link } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import { useCurrentBreakpointName } from 'react-socks';
import _ from 'underscore';

const AutomationTiles = (props) => {
    let constants = props.app.config.constants,
        generateTile = (tile, key) => {
            let tileIcons = null,
                generateIcon = (type) => {
                    let icon = '',
                        iconType = type;

                    if (type === 'share') {
                        icon = <i className="icon ion-android-share-alt"/>;
                    } else if (type === 'ai') {
                        icon = <i className="ds-icon icon-ai"/>;
                    } else {
                        let IconElement = IconFactory[ConstantMixin.getIconIndexByCode(type)];
                        iconType = ConstantMixin.getIconIndexByCode(type);
                        icon = <IconElement round="true" automation="true"/>;
                    }

                    return (
                        <div className={`automation-icon ${iconType}`}>
                            {icon}
                        </div>
                    );
                };

            if (tile.destination) {
                tileIcons = (
                    <div className="tile-icons">
                        {generateIcon(tile.source)}
                        <div className="tile-divider">
                            <i className="icon ion-arrow-right-c"/>
                        </div>
                        {generateIcon(tile.destination)}
                    </div>
                )
            } else {
                tileIcons = (
                    <div className="tile-icons">
                        {generateIcon(tile.source)}
                    </div>
                );
            }


            return (
                <Link key={tile.id} to={tile.link} className="automated-tile-link" onClick={(e) => {
                    if (props.recordEvent !== undefined) {
                        props.recordEvent({
                            pub_id: props.user.detail.id,
                            event_name: 'Automation Tile Clicked',
                            event_data: {
                                tile: tile.id
                            }
                        });
                    }
                }}>
                    <div className="automated-tile">
                        <div className="tile-copy">
                            {tile.copy}
                        </div>
                        <div className="tile-icons-wrapper">
                            {tileIcons}
                        </div>
                    </div>
                </Link>
            );
        };

    let analyzerLink = '/stats/analyzer?facebook',
        facebookAccounts = (_.isArray(props.socials.counts)) ? props.socials.counts.find(({type}) => { return type === constants.POST_SVC_FACEBOOK; }) : null;

    if (!facebookAccounts || (facebookAccounts && facebookAccounts.count === 0)) {
        analyzerLink = '/config/socials?add&redirect=' + encodeURIComponent("/stats/analyzer");
    }

    const tiles = [
        {id: 'feed_to_media_profiles', copy: <span><strong>Post RSS Feed</strong> to your social media profiles</span>, source: constants.POST_SVC_FEED, destination: 'share', link: '/share/automate/new/inputs/feed?automation'},
        {id: 'ig_native_to_twitter', copy: <span><strong>Share Instagram Reels</strong> to your social channels</span>, source: constants.POST_SVC_INSTAGRAM_BUSINESS, destination: 'share', link: '/share/automate/new/inputs/instagram?automation'},
        {id: 'schedule_to_all_profiles', copy: <span><strong>Schedule an update</strong> to all my social media profiles</span>, source: 'share', destination: '', link: '/content/post'},
        {id: 'share_youtube', copy: <span><strong>Share your Instagram Reels</strong> to YouTube</span>, source: constants.POST_SVC_INSTAGRAM_BUSINESS, destination: constants.POST_SVC_YOUTUBE, link: '/share/automate/new/inputs/youtube?automation'},
        {id: 'generate_ai_post', copy: <span><strong>Use AI</strong> to generate a post and share to your social profiles</span>, source: constants.POST_SVC_INSTAGRAM_BUSINESS, destination: constants.POST_SVC_GMYBUSINESS, link: '/content/post?helper'},
        {id: 'facebook_analyzer', copy: <span><strong>Identify your top Facebook posts</strong> and reshare them</span>, source: constants.POST_SVC_FACEBOOK, destination: 'share', link: analyzerLink},
        {id: 'ig_to_pinterest', copy: <span><strong>Import your Instagrams</strong> to Pinterest</span>, source: constants.POST_SVC_INSTAGRAM_BUSINESS, destination: constants.POST_SVC_PINTEREST, link: '/share/automate/new/inputs/instagram?automation'},
        {id: 'facebook_to_profiles', copy: <span><strong>Share new Facebook posts</strong> across your social profiles</span>, source: constants.POST_SVC_FACEBOOK, destination: 'share', link: '/share/automate/new/inputs/facebook?automation'},
        {id: 'website_to_profiles', copy: <span><strong>Auto share a website</strong> to your social profiles</span>, source: constants.POST_SVC_FEED, destination: 'share', link: '/share/automate/new/inputs/feed?automation'},
        {id: 'rss_feed_to_linkedin', copy: <span><strong>Auto publish new RSS feed items</strong> to LinkedIn</span>, source: constants.POST_SVC_FEED, destination: constants.POST_SVC_LINKEDIN, link: '/share/automate/new/inputs/feed?automation'},
        {id: 'ai_link_to_post', copy: <span><strong>Use AI</strong> to turn a link into a social media post</span>, source: 'ai', destination: '', link: '/content/post?helper=link'},
        {id: 'ig_to_bluesky', copy: <span><strong>Share your Instagrams</strong> on Bluesky</span>, source: constants.POST_SVC_INSTAGRAM_BUSINESS, destination: constants.POST_SVC_BLUESKY, link: '/share/automate/new/inputs/instagram?automation'},
    ];


    useEffect(() => {
        if (props.recordEvent !== undefined) {
            props.recordEvent({
                pub_id: props.user.detail.id,
                event_name: 'Automation Tiles Viewed'
            })
        }
        // grab the socials to see if there are any facebooks
        props.getSocials();
    }, []);

    let mobileClass = useCurrentBreakpointName() === 'mobile' ? 'mobile' : '';

    let content = (
        <div className={`automated-tiles-wrapper ${mobileClass}`}>
            <div className="automated-tiles-header">Get started with popular automations</div>
            <div className="automated-tiles">
                {tiles.map((tile, i) => {
                    return generateTile(tile, i);
                })}
            </div>
            <div className="no-tiles-enticed">
                <Link to="/share/automate/new/inputs" onClick={() => {
                    if (props.recordEvent !== undefined) {
                        props.recordEvent({
                            pub_id: props.user.detail.id,
                            event_name: 'Automation Explore More Link Clicked'
                        });
                    }
                }}>
                    Explore more automations
                </Link>
            </div>
        </div>
    );

    return (
        <div>
            <Content
                {...props}
                main={content}/>
        </div>
    );
};

export default ComponentWithContext(AutomationTiles);
